import Presenter from './Presenter';
import { IContainerProps } from './types';

const SearchBarContainer = (props: IContainerProps) => {

    return (
        <Presenter {...props} />
    );
};

export default SearchBarContainer;
